<template>

  <div class="padded">
    <h3><i class="fa fa-dollar" />&nbsp;New Revenue Report</h3></br />

    <el-form :inline="true">
      <select-year v-model="year" :back="7" />
    </el-form>

    <hr />
    <h4>New Revenue: <b>{{year}}</b></h4>

    <pie-chart
    :data="chartRevenue"
    thousands=","
    legend="right"
    :colors="colours"
    :download="true" />

    <hr />

    <h4>New Revenue: <b>{{year}}</b></h4>
    <el-table
       :data="revenue"
       border
       stripe
       show-summary
       sum-text="Totals"
       :summary-method="summaryFormatter"
       style="width: 100%">

       <el-table-column prop="period"
        label="Period">
       </el-table-column>

       <el-table-column prop="status"
        label="Status">
       </el-table-column>

       <el-table-column prop="sites"
        label="Sites"
        :formatter="formatInt">
       </el-table-column>

       <el-table-column prop="ways"
       label="Ways"
        sortable
        align="right"
        :formatter="formatInt">
       </el-table-column>

       <el-table-column
          prop="fees"
          label="Fees"
          sortable
          align="right"
          :formatter="formatNum">
       </el-table-column>

       <el-table-column
          prop="capex"
          label="CAPEX"
          sortable
          align="right"
          :formatter="formatNum">
       </el-table-column>
     </el-table>
    <hr />

  </div>
</template>

<script>

import {chartColors} from '@/components/Data'

import PostMixins from '@/mixins/PostMixins'
import ElTableMixins from '@/mixins/ElTableMixins'
import NumberMixins from '@/mixins/NumberMixins'

export default {
  mixins: [PostMixins, ElTableMixins, NumberMixins],

  methods: {
    init () {
      this.chartRevenue = []
      this.fetchData('report/finance/revenue/' + this.year, this.revenueData, 'Finance Revenue stats')
    },

    revenueData (data) {
      this.revenue = data

      if (this.revenue && this.revenue.length > 0) {

        for (var i = 0; i < this.revenue.length; i++) {
          let label = this.revenue[i].period + ' (' + this.revenue[i].status + ')'

          this.chartRevenue.push([label, Number(Number(this.revenue[i].fees).toFixed(2))])
        }

      }
    },

    summaryFormatter (param) {
      return this.totalColumns(param, 'Totals', ['sites', 'ways'], ['fees', 'capex'])
    }

  },

  watch: {
    year: function () {
      this.init()
    }
  },

  data () {
    return {
      year: (new Date()).getFullYear(),
      revenue: [],
      chartRevenue: [],
      colours: chartColors
    }
  },

  created () {
    this.init()
  }
}
</script>



// WEBPACK FOOTER //
// RevenueReport.vue?e03a977a